import { ContractAgency } from '@core/models/contract-agency.model';
import { ContractCgvStatus } from '@core/models/contract-cgv-status.model';
import { ContractCgvType } from '@core/models/contract-cgv-type.model';
import { ContractSector } from '@core/models/contract-sector.model';
import { ContractState } from '@core/models/contract-state.model';
import { ContractUt } from '@core/models/contract-ut.model';

export interface JsonContractInformations {
  id: string;
  contractId: number;
  advertiserStatus: ContractCgvStatus;
  sector: ContractSector;
  contractManager: ContractUt;
  customerServiceManager: ContractUt;
  centralAgency: ContractAgency;
  contractType: ContractCgvType;
  salesServiceManager: ContractUt;
  billingManager: ContractUt;
  sentOn: string;
  customerReturnDate: string;
  state: ContractState;
  isActive: number;
  createdAt: string;
  updatedAt: string;
}

export class ContractInformations {
  id: string;
  contractId: number;
  advertiserStatus: ContractCgvStatus;
  sector: ContractSector;
  contractManager: ContractUt;
  customerServiceManager: ContractUt;
  centralAgency: ContractAgency;
  contractType: ContractCgvType;
  salesServiceManager: ContractUt;
  billingManager: ContractUt;
  sentOn: string;
  customerReturnDate: string;
  state: ContractState;
  isActive: number;
  createdAt: string;
  updatedAt: string;

  constructor(jsonContractInformations: JsonContractInformations = null) {
    if (jsonContractInformations) {
      this.id = jsonContractInformations.id;
      this.contractId = jsonContractInformations.contractId;
      this.advertiserStatus = jsonContractInformations.advertiserStatus;
      this.sector = jsonContractInformations.sector;
      this.contractManager = jsonContractInformations.contractManager;
      this.customerServiceManager = jsonContractInformations.customerServiceManager;
      this.centralAgency = jsonContractInformations.centralAgency;
      this.contractType = jsonContractInformations.contractType;
      this.salesServiceManager = jsonContractInformations.salesServiceManager;
      this.billingManager = jsonContractInformations.billingManager;
      this.sentOn = jsonContractInformations.sentOn;
      this.customerReturnDate = jsonContractInformations.customerReturnDate;
      this.state = jsonContractInformations.state;
      this.isActive = jsonContractInformations.isActive;
      this.createdAt = jsonContractInformations.createdAt;
      this.updatedAt = jsonContractInformations.updatedAt;
    }
  }
}
